

export default function(value, tt, sign) {
    let v = isNaN(Math.abs(value))  ? 0 : parseFloat(value)
    var n = Math.trunc(v * 100) / 100,
  
  /*   c = isNaN(c = Math.abs(c)) ? 2 : c,  */
    c = 2,
    d = d == undefined ? "." : d, 
    t = tt == undefined ? " " : tt, 
    s = sign == undefined ? (n < 0 ? "-" : "") : (n < 0 ? sign : ""), 
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  }